import React from "react";

function Loading() {
  return <div>loading . . . . . .</div>;
}

export default Loading;
